import { Button, ButtonSize } from '@hourly-hds/components';
import StepLayout from '../StepLayout';

interface MagicLinkSentProps {
  onReturn: () => void;
}

const MagicLinkSent = ({ onReturn }: MagicLinkSentProps) => {
  return (
    <StepLayout>
      <StepLayout.Header>
        <StepLayout.Title>Magic Link 🪄</StepLayout.Title>
        <StepLayout.Description>
          We sent a magic link to your email on file. Please follow the instructions in the email to
          login.
        </StepLayout.Description>
      </StepLayout.Header>
      <StepLayout.Actions>
        <Button label="Return" size={ButtonSize.Large} onClick={onReturn} />
      </StepLayout.Actions>
    </StepLayout>
  );
};

export default MagicLinkSent;
